import classNames from 'classnames';
import { FC } from 'react';

type SectionTitleProps = {
  title: string;
  className?: string;
};

const SectionTitle: FC<SectionTitleProps> = ({ title, className }) => (
  <h3
    className={classNames(
      'text-primary font-semibold text-3xl text-center',
      className,
    )}
  >
    {title}
  </h3>
);

export default SectionTitle;
